import React from 'react'

import { Box, Icon, Text } from '@vividseats/vivid-ui-kit'

import { PATHS } from '@/constants'

import styles from './styles.module.scss'

const BuyerGuaranteeBox: React.FC = () => {
    return (
        <Box
            data-testid="buyer-guarantee-box"
            mobilePadding={3}
            tabletPadding={3}
            desktopPadding={3}
            marginTop={4}
            marginBottom={4}
            className={styles.buyerGuaranteeBox}
        >
            <Text altFont weight="bold" className={styles.title}>
                <Icon type="ticket-guarantee-filled" size="sm" className={styles.guaranteeIcon} />
                100% Buyer Guarantee
            </Text>
            <Text altFont size="sm">
                {'This order is fully backed by our '}
                <a href={PATHS.BUYER_GUARANTEE} className={styles.guaranteeLink} target="_blank" rel="noreferrer">
                    100% Buyer Guarantee
                </a>
                . Enjoy authentic, on-time tickets or receive full compensation for your purchase.
            </Text>
        </Box>
    )
}

export default BuyerGuaranteeBox
